import { render, staticRenderFns } from "./ThirdPartyUsage.vue?vue&type=template&id=0dbeda48&scoped=true&"
import script from "./ThirdPartyUsage.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbeda48",
  null
  
)

export default component.exports